import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams, useLocation } from "react-router-dom";
import { getDdOptionForUI } from "../../store/reducer/ddOption/ddOptionSlice";
import {
  getCustomerForUI660,
  getOpportunityByCustomerId660,
  getDrawingByOpportunityFor660,
  addExpenseSnags,
  getExpenseSnags,
  deleteExpenseSnag,
} from "../../store/reducer/drawing/drawingSlice";
import Notes from "../Notes/Notes";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import DrawingTabs from "./DrawingTabs";

function ExpenseSnags() {
  const { id, drawing_id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const [opportunityData, setOpportunityData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [drwaingData, setDrwaingData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [customer_id, setCustomerId] = useState(null);
  const [customer, setCustomer] = useState([]);

  useEffect(() => {
    setLoading(true);
     getCustomerByDrwaing(id)
    // dispatch(getDdOptionForUI());
    dispatch(getCustomerForUI660()).then((result) => {
      if (result.payload) {
        //setCustomerData(result.payload.data);
        setCustomer(result.payload.data);
        setLoading(false);
      }
    });
    dispatch(getExpenseSnags({ customer_id,page, limit })).then((result) => {
          if (result.payload) {
            setCustomerData(result.payload.data.rows);
            setLoading(false);
          }
        });
  }, []);

  const getOppByCustomerId = (customer_id) => {
    setLoading(true);
    dispatch(getOpportunityByCustomerId660(customer_id)).then((result) => {
      if (result.payload) {
        setOpportunityData(result.payload.data);
        setLoading(false);
      }
    });
  };

  const getCustomerByDrwaing = (customer_id) => {
    setLoading(true);
    dispatch(getDrawingByOpportunityFor660(customer_id)).then((result) => {
      if (result.payload) {
        setDrwaingData(result.payload);
        setLoading(false);
      }
    });
  };

  const initialValues = {
    customer_id: "",
    opportunity_id: id,
    title: "",
    before_photo: [],
    after_photo: [],
    before_video: [],
    after_video: [],
    location: "",
    comments: "",
    date_reported: "",
    date_completed: "",
    status: 660
  };

    const handlePageClick = ({ selected }) => {
      const page = selected + 1;
      setPage(page);
      setLimit(10);
      dispatch(getExpenseSnags({ page, limit }));
    };

  
    const handleDeleteExpenseSnag = (id) => {
      if (window.confirm("Are you sure you want to delete this expense snag?")) {
        dispatch(deleteExpenseSnag(id))
          .then(() => {
            toast.success("Expense Snag deleted!");
          })
          .catch((error) => {
            alert("Failed to delete expense snag. Please try again.");
          });
  
        // dispatch(getExpenseSnags()).then((result) => {
        //   setLoading(true);
        //   if (result.payload) {
        //     setCustomerData(result.payload.data.rows);
        //     setLoading(false);
        //   }
        // });

         getCustomerByDrwaing(id)
         setLoading(false);
      }
    };

  const getCustomer = (customer_id) => {
      setCustomerId(customer_id);
      dispatch(getExpenseSnags({ customer_id, page, limit }))
        .then((result) => {
          if (result.payload && result.payload.data) {
            setCustomerData(result.payload.data.rows);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
          setLoading(false);
        });
    };

    const handleSubmit = (values) => {
      console.log(values)
    setLoading(true);
    const formData = new FormData();
    Object.keys(values).forEach((fieldName) => {
      formData.append(fieldName, values[fieldName]);
    });

    formData.append("drawing_id",drawing_id);
    
    if (values.before_photo) {
      values.before_photo.forEach((file) => {
        formData.append("before_photo", file);
      });
    }

     if (values.after_photo) {
      values.after_photo.forEach((file) => {
        formData.append("after_photo", file);
      });
    }

    if (values.before_video) {
      values.before_video.forEach((file) => {
        formData.append("before_video", file);
      });
    }

     if (values.after_video) {
      values.after_video.forEach((file) => {
        formData.append("after_video", file);
      });
    }

    dispatch(addExpenseSnags(formData)).then((result) => {
      if (result.payload != undefined) {
        getCustomerByDrwaing(id)
        toast.success(result.payload.message);
      } else {
        toast.error("Proposal not finilized. Please try again.");
      }
      setLoading(false);
    });
  };


  return (
    <>
      <div className="grid grid-cols-3 items-center mb-[30px]">
        <div className="flex gap-[16px] items-center">
          <Link to={`/opportunity/${id}`}>
            <div className="bg-[#F8F8F8] rounded-[10px] p-[8px]">
              <img
                className="w-[24px]"
                src={process.env.PUBLIC_URL + "/icons/back.png"}
                alt="back icon"
              />
            </div>
          </Link>
          <div className="flex flex-col">
            <span className="font-Inter font-[400] leading-[16px] text-[#9E9E9E] text-[14px]">
              Snags
            </span>
            <span className="font-Inter font-[700] leading-[30px] text-[24px]">
              Snags
            </span>
          </div>
        </div>
        <div className="font-Inter font-[500] leading-[30px] text-[18px] text-center">
          {opportunityData.id}-{drawing_id}-{opportunityData.opportunity_name}
        </div>
        <Notes
          type="drawing-commercialinvoice-history"
          drawing_id={drawing_id}
        />
      </div>

      <DrawingTabs />

      {loading && (
        <div className="text-center">
          <FontAwesomeIcon
            icon={faSpinner}
            size="2xl"
            style={{ color: "#55A14A" }}
            spin
          />
        </div>
      )}

      <div className="flex flex-col mt-[20px] gap-[40px]">
        <div className="w-full mt-6">
          <div className="bg-[#F8F8F8] rounded-[12px] p-6">
            <div className="md:flex justify-between items-center p-[12px]">
              <div className="leading-[30px] font-Mulish font-[700] text-[20px] mb-[8px] md:mb-0">
                <span>Add Snags</span>
              </div>
              {/* <div className="flex justify-end">
                <a
                  href={`/opportunity/${id}/drawing/${drawing_id}/expense-snags-list`}
                  className="bg-[#55A14A] text-white px-5 py-2 rounded-lg hover:bg-[#3A8A3A]"
                >
                  Snag List
                </a>
              </div> */}
            </div>

            <div className="mt-4">
              <Formik
                initialValues={initialValues}
                // validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({
                  isSubmitting,
                  values,
                  errors,
                  touched,
                  setFieldValue,
                  handleSubmit,
                }) => (
                  <Form>
                    <div className="md:flex justify-between  p-[12px]">
                      <div className="w-[45%]">
                        {/* <div className="mb-4">
                          <label
                            className="block text-gray-700 text-sm font-bold mb-2"
                            htmlFor="customer_id"
                          >
                            Customer
                          </label>
                          <Field
                            as="select"
                            className="block appearance-none w-full bg-white border border-gray-200 text-gray-700 py-2 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            id="customer_id"
                            name="customer_id"
                            onChange={(e) => {
                              setFieldValue("customer_id", e.target.value);
                              getOppByCustomerId(e.target.value);
                            }}
                          >
                            <option value={""}>Select Customer</option>
                            {customerData.map((customer) => (
                              <option value={customer.id} key={customer.id}>
                                {customer.customer_name}
                              </option>
                            ))}
                          </Field>
                        </div> */}

                        <div className="mb-4">
                          <label
                            className="block text-gray-700 text-sm font-bold mb-2"
                            htmlFor="drawing_id"
                          >
                            Status
                          </label>
                          <Field
                            as="select"
                            className="block appearance-none w-full bg-white border border-gray-200 text-gray-700 py-2 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            id="status"
                            name="status"
                            selected
                            defaultValue={drwaingData[0]?.status}
                            onLoad={() => {
                              setFieldValue("status", drwaingData[0]?.status);
                            }}
                          >
                            <option value={drwaingData[0]?.status}>
                              {drwaingData[0]?.field_code}
                            </option>
                          </Field>
                        </div>
                        <div className="mb-4">
                          <label
                            className="block text-gray-700 text-sm font-bold mb-2"
                            htmlFor="title"
                          >
                            Title of Snag
                          </label>
                          <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="title"
                            type="text"
                            name="title"
                            placeholder="Enter title of snag"
                            required
                            onChange={(e) => {
                              setFieldValue("title", e.target.value);
                            }}
                          />
                        </div>
                        <div className="mb-4">
                          <label
                            className="block text-gray-700 text-sm font-bold mb-2"
                            htmlFor="beforephoto"
                          >
                            Before Photo
                          </label>
                          <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="before_photo"
                            type="file"
                            name="before_photo"
                            accept="image/*"
                            placeholder="Upload before photo"
                            multiple
                            onChange={(e) => {
                              setFieldValue("before_photo", [
                                ...e.target.files,
                              ]);
                            }}
                          />
                          {values.before_photo.map((f, i) => (
                            <p key={i}>Before: {f.name}</p>
                          ))}
                        </div>
                         <div className="mb-4">
                          <label
                            className="block text-gray-700 text-sm font-bold mb-2"
                            htmlFor="beforephoto"
                          >
                            Before Video
                          </label>
                          <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="before_video"
                            type="file"
                            name="before_video"
                            accept="video/*"
                            placeholder="Upload before video"
                            onChange={(e) => {
                              setFieldValue("before_video", [
                                ...e.target.files,
                              ]);
                            }}
                          />
                          {values.before_video.map((f, i) => (
                            <p key={i}>Before: {f.name}</p>
                          ))}
                        </div>
                        <div className="mb-4">
                          <label
                            className="block text-gray-700 text-sm font-bold mb-2"
                            htmlFor="date_completed"
                          >
                            Date Completed
                          </label>
                          <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="date_completed"
                            type="date"
                            name="date_completed"
                            placeholder="Enter date completed"
                            required
                            onChange={(e) => {
                              setFieldValue("date_completed", e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <div className="w-[45%]">
                        {/* <div className="mb-4">
                          <label
                            className="block text-gray-700 text-sm font-bold mb-2"
                            htmlFor="opportunity_id"
                          >
                            Opportunity
                          </label>
                          <div className="relative">
                            <Field
                              as="select"
                              className="block appearance-none w-full bg-white border border-gray-200 text-gray-700 py-2 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                              id="opportunity_id"
                              name="opportunity_id"
                              onChange={(e) => {
                                setFieldValue("opportunity_id", e.target.value);
                                getCustomerByDrwaing(e.target.value);
                              }}
                            >
                              <option value={""}>Select opportunity</option>
                              {opportunityData.map((opportunity) => (
                                <option
                                  value={opportunity.id}
                                  key={opportunity.id}
                                >
                                  {opportunity.opportunity_name}
                                </option>
                              ))}
                            </Field>
                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                              <svg
                                className="fill-current h-4 w-4"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                              >
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                              </svg>
                            </div>
                          </div>
                          {errors.opportunity_id && touched.opportunity_id ? (
                            <div className="text-red-700">
                              {errors.opportunity_id}
                            </div>
                          ) : null}
                        </div> */}
                        <div className="mb-4">
                          <label
                            className="block text-gray-700 text-sm font-bold mb-2"
                            htmlFor="location"
                          >
                            Location
                          </label>
                          <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="location"
                            name="location"
                            placeholder="Enter location"
                            required
                            onChange={(e) => {
                              setFieldValue("location", e.target.value);
                            }}
                          />
                        </div>
                        <div className="mb-4">
                          <label
                            className="block text-gray-700 text-sm font-bold mb-2"
                            htmlFor="comments"
                          >
                            Comments
                          </label>
                          <textarea
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="comments"
                            name="comments"
                            placeholder="Enter comments"
                            required
                            onChange={(e) => {
                              setFieldValue("comments", e.target.value);
                            }}
                          />
                        </div>
                        <div className="mb-4">
                          <label
                            className="block text-gray-700 text-sm font-bold mb-2"
                            htmlFor="afterphoto"
                          >
                            After Photo
                          </label>
                          <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="after_photo"
                            type="file"
                            name="after_photo"
                            accept="image/*"
                            placeholder="Enter after photo"
                            multiple
                            onChange={(e) => {
                              setFieldValue("after_photo", [...e.target.files]);
                            }}
                          />
                          {values.after_photo.map((f, i) => (
                            <p key={i}>After: {f.name}</p>
                          ))}
                        </div>
                         <div className="mb-4">
                          <label
                            className="block text-gray-700 text-sm font-bold mb-2"
                            htmlFor="afterphoto"
                          >
                            After Video
                          </label>
                          <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="after_video"
                            type="file"
                            name="after_video"
                            accept="video/*"
                            placeholder="Enter after video"
                            onChange={(e) => {
                              setFieldValue("after_video", [...e.target.files]);
                            }}
                          />
                          {values.after_video.map((f, i) => (
                            <p key={i}>After: {f.name}</p>
                          ))}
                        </div>
                        <div className="mb-4">
                          <label
                            className="block text-gray-700 text-sm font-bold mb-2"
                            htmlFor="datereport"
                          >
                            Date Reported
                          </label>
                          <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id=" date_reported"
                            type="date"
                            name=" date_reported"
                            placeholder="Enter date reported"
                            required
                            onChange={(e) => {
                              setFieldValue("date_reported", e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-center mt-6">
                      <button className="bg-[#55A14A] hover:bg-[#4CAF50] text-white font-bold py-2 px-4 rounded">
                        Submit
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>

          <div className="w-full mt-6">
            <div className=" rounded-[12px] p-6">
              <div className="md:flex justify-between items-center p-[12px]">
                <div className="leading-[30px] font-Mulish font-[700] text-[20px] mb-[8px] md:mb-0">
                  <span>Snags List</span>
                </div>
              </div>
              <div className="w-[20%] mb-4">
                <label
                  className="block text-gray-700 text-sm font-bold mb-2"
                  htmlFor="customer_id"
                >
                  Customer Filter
                </label>
                <select
                  id="customer_id"
                  name="customer_id"
                  className="w-full bg-white border border-gray-200 rounded-[12px] py-3 px-4 pr-12 leading-tight focus:outline-none focus:border-gray-500"
                  onChange={(e) => getCustomer(e.target.value)}
                >
                  <option value={""}>Select Customer</option>
                  {customer.map((cust) => (
                    <option value={cust.id} key={cust.id}>
                      {cust.customer_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mt-4">
                <table className="w-full text-sm text-center ">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Opportunity Name</th>
                      <th>Customer Name</th>
                      <th>Location</th>
                      <th>Comments</th>
                      <th>Date Reported</th>
                      <th>Date Completed</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {customerData?.map((data, index) => (
                      <tr key={index} className="border border-gray-200">
                        <td className="text-center border border-gray-200">
                          {data.title}
                        </td>
                        <td className="text-center border border-gray-200">
                          {data.opportunity_name}
                        </td>
                        <td className="text-center border border-gray-200">
                          {data.customer_name}
                        </td>
                        <td className="text-center border border-gray-200">
                          {data.location}
                        </td>
                        <td className="text-center border border-gray-200">
                          {data.comments}
                        </td>
                        <td className="text-center border border-gray-200">
                          {data.date_reported}
                        </td>
                        <td className="text-center border border-gray-200">
                          {data.date_completed}
                        </td>
                        <td>
                          <div className="text-center">
                            <a
                              href={`/opportunity/${id}/drawing/${drawing_id}/expense-snags/edit/${data.id}`}
                              className="text-center py-[8px] px-[8px] font-[500] font-Inter text-[12px] text-[#55A14A] rounded-[12px] border border-[#55A14A]"
                            >
                              Edit
                            </a>
                            &nbsp;
                            <button
                              className="text-center py-[5px] px-[5px] font-[500] font-Inter text-[12px] text-[#55A14A] rounded-[12px] border border-[#55A14A]"
                              onClick={() => handleDeleteExpenseSnag(data.id)}
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              &nbsp;
              <div className="w-full flex justify-end">
                <ReactPaginate
                  className="react_pagination_ul"
                  breakLabel={
                    <span className="w-10 h-10 flex justify-center items-center bg-white rounded-md mr-4">
                      {"<"}
                    </span>
                  }
                  nextLabel={
                    <span className="w-10 h-10 flex justify-center items-center bg-white rounded-md">
                      {">"}
                    </span>
                  }
                  onPageChange={handlePageClick}
                  pageCount={Math.ceil(customerData.length / 10)}
                  previousLabel={
                    <span className="w-10 h-10 flex justify-center items-center bg-white rounded-md mr-4">
                      {"<"}
                    </span>
                  }
                  activeClassName="bg-black text-white"
                  pageClassName="block text-black  hover:bg-black hover:text-white rounded-md  mr-4"
                  pageLinkClassName="w-10 h-10 flex justify-center items-center"
                  containerClassName="flex items-center justify-center "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExpenseSnags;
